/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './SegurosConteudos.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function SegurosConteudos() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguros-conteudos">
        <ContainerHome24>
          <h2 className="seguros-conteudos-titulo">Consulte nossos conteúdos</h2>
          <div className="is-mobi">
            {/* <h2 className="seguros-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`seguros-conteudos-slide ${className}`}>
                    <a
                      href="blog/seguro-auto.html"
                      target="_blank"
                      className="seguros-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-14/capa.jpg" />
                        <img
                          src="static/amp/blog/post-14/capa.png"
                          alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                        />
                      </picture>

                      <div className="seguros-conteudos-card-textos">
                        <h3 className="seguros-conteudos-slide-titulo">
                          Proteja seu veículo com o seguro auto
                        </h3>
                        <p className="seguros-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`seguros-conteudos-slide ${className}`}>
                    <a
                      href="blog/confira-o-que-fazer-apos-assinar-o-contrato-de-financiamento-de-veiculo.html"
                      target="_blank"
                      className="seguros-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-23/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-23/capa.jpg" />
                        <img
                          src="static/amp/blog/post-23/capa.png"
                          alt="pessoa assinando um contrato de financiamento sobre uma prancheta ao lado de um computador"
                        />
                      </picture>

                      <div className="seguros-conteudos-card-textos">
                        <h3 className="seguros-conteudos-slide-titulo">
                          O que fazer após assinar o contrato de financiamento do veículo?
                        </h3>
                        <p className="seguros-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`seguros-conteudos-slide ${className}`}>
                    <a
                      href="blog/servicos-automotivos-webmotors-car10.html"
                      target="_blank"
                      className="seguros-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-8/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-8/capa.jpg" />
                        <img
                          src="static/amp/blog/post-8/capa.jpg"
                          alt="mecânico segurando um pneu em uma oficina fazendo sinal positivo com as mãos"
                        />
                      </picture>

                      <div className="seguros-conteudos-card-textos">
                        <h3 className="seguros-conteudos-slide-titulo">
                          Serviços Automotivos: Webmotors Car10
                        </h3>
                        <p className="seguros-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            {/* <h2 className="seguros-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <div className="cards-desk">
              <a href="blog/seguro-auto.html" target="_blank" className="seguros-conteudos-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-14/capa.jpg" />
                  <img
                    src="static/amp/blog/post-14/capa.png"
                    alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                  />
                </picture>

                <div className="seguros-conteudos-card-textos">
                  <h3 className="seguros-conteudos-slide-titulo">
                    Proteja seu veículo com o seguro auto
                  </h3>
                  <p className="seguros-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/confira-o-que-fazer-apos-assinar-o-contrato-de-financiamento-de-veiculo.html"
                target="_blank"
                className="seguros-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-23/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-23/capa.jpg" />
                  <img
                    src="static/amp/blog/post-23/capa.png"
                    alt="pessoa assinando um contrato de financiamento sobre uma prancheta ao lado de um computador"
                  />
                </picture>

                <div className="seguros-conteudos-card-textos">
                  <h3 className="seguros-conteudos-slide-titulo">
                    O que fazer após assinar o contrato de financiamento do veículo?
                  </h3>
                  <p className="seguros-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/servicos-automotivos-webmotors-car10.html"
                target="_blank"
                className="seguros-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-8/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-8/capa.jpg" />
                  <img
                    src="static/amp/blog/post-8/capa.jpg"
                    alt="mecânico segurando um pneu em uma oficina fazendo sinal positivo com as mãos"
                  />
                </picture>

                <div className="seguros-conteudos-card-textos">
                  <h3 className="seguros-conteudos-slide-titulo">
                    Serviços Automotivos: Webmotors Car10
                  </h3>
                  <p className="seguros-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default SegurosConteudos;
